<template>
  <div
    class="ll-select-bar"
    :style="{marginTop:marginTop+'px'}"
  >
    <slot />
    <div
      v-if="top"
      class="ll-select-bar_top"
    >
      <slot name="top" />
    </div>
    <div
      class="ll-select-bar_content"
      :class="{twoItem:twoItem,threeItem:threeItem,top:top,fourItem:fourItem,widthStretch:widthStretch,isTwo:isTwo}"
    >
      <div
        v-if="twoItem || threeItem || fourItem"
        class="ll-select-bar_content-item"
      >
        <slot name="content1" />
      </div>
      <div
        v-if="twoItem || threeItem || fourItem"
        class="ll-select-bar_content-item"
      >
        <slot name="content2" />
      </div>
      <div
        v-if="threeItem || fourItem"
        class="ll-select-bar_content-item"
      >
        <slot name="content3" />
      </div>
      <div
        v-if="fourItem"
        class="ll-select-bar_content-item"
      >
        <slot name="content4" />
      </div>
    </div>
    <div
      v-if="btns"
      class="ll-select-bar_btns"
    >
      <slot name="btns" />
    </div>
  </div>
</template>
<script>
export default {
  name: "LlSelectBar",
  props: {
    four: {
      type: Boolean,
      default: false,
    },
    two: {
      type: Boolean,
      default: false,
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    twoItem: {
      type: Boolean,
      default: false,
    },
    three: {
      type: Boolean,
      default: false,
    },
    btns: {
      type: Boolean,
      default: false,
    },
    top: {
      type: Boolean,
      default: false,
    },
    threeItem: {
      type: Boolean,
      default: false,
    },
    fourItem: {
      type: Boolean,
      default: false,
    },
    widthStretch: {
      type: Boolean,
      default: false,
    },
    isTwo: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-select-bar";
</style>